import * as React from 'react'
import { Badge, badges } from 'DVWebNodeUI'

export interface IDateTimeBadgeProps {
  dateTimeBadge?: string
}

export const DateTime = ({ dateTimeBadge }: IDateTimeBadgeProps) => (
  dateTimeBadge &&
  (<Badge use={badges.TEXT}>
    <span data-automation-id="date-time-badge">{dateTimeBadge}</span>
  </Badge>) || null
)
